import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Dossier/Sale/SelfSupply/OrganizedUnits', method: 'GET', body: null, token: token })
}
